var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard_classification"},[_c('div',{staticClass:"main_div"},[_c('div',{staticClass:"tab_content"},[_c(_vm.activeTab.component,_vm._b({tag:"component"},'component',_vm.activeTab.props,false))],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }